import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getAllUsersAdmin } from "../../../actions/auth";
import AdminPage from "../_components/AdminPage";
import AdminCreateButton from "../_components/AdminCreateButton";
import AdminTable from "../_components/AdminTable";
import AdminUserItem from "./AdminUseritem";

const TABLE_COLUMNS = [
  { key: "no", title: "#", width: "tw:w-[60px] tw:rounded-tl-[5px]", skeleton: "narrow" },
  { key: "name", title: "Name", width: "tw:w-[320px]" },
  { key: "email", title: "Email", width: "tw:w-[320px]" },
  { key: "createdOn", title: "Created Date", width: "tw:w-[180px]" },
  { key: "action", title: "Action", width: "tw:w-[120px] tw:rounded-tr-[5px]", sticky: true, align: "center" },
];

const AdminUserList = () => {
  const auth = useSelector((state) => state.auth);
  const { loading, users, user } = auth;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllUsersAdmin());
  }, [dispatch]);

  return (
    <AdminPage title="Admin User List" actions={<AdminCreateButton to="/admin/adduser" label="Add Admin User" />}>
      <AdminTable
        columns={TABLE_COLUMNS}
        minWidth={1000}
        loading={loading && !users}
        skeletonRowCount={8}
        isEmpty={!users?.length}
        emptyText="No admin users found."
      >
        {users?.map((item, index) => (
          <AdminUserItem key={item._id} user={item} currentUser={user} count={index} />
        ))}
      </AdminTable>
    </AdminPage>
  );
};

export default AdminUserList;
